export const periodsopt = [
  { value: '0', label: 'Period 0', name: 'P0' },
  { value: '1', label: 'Period 1', name: 'P1' },
  { value: '2', label: 'Period 2', name: 'P2' },
  { value: '3', label: 'Period 3', name: 'P3' },
  { value: '4', label: 'Period 4', name: 'P4' },
  { value: '5', label: 'Period 5', name: 'P5' },
  { value: '6', label: 'Period 6', name: 'P6' },
  { value: '7', label: 'Period 7', name: 'P7' },
  { value: '8', label: 'Period 8', name: 'P8' },
  { value: '9', label: 'Period 9', name: 'P9' },
];

export const reasons = [
  { value: 'C01', label: 'Court' },
  { value: 'R02', label: 'Religious Reason' },
  { value: 'M02', label: 'Non-Medical' },
  { value: 'D01', label: 'Funeral/Bereavement' },
  { value: 'M01', label: 'Medical Appointment' },
  { value: 'I01', label: 'Illness' },
];

// export const earlyLeaveReasons = [
//   { value: 'E02', label: 'Health Office' },
//   { value: 'E03', label: 'Court' },
//   { value: 'E04', label: 'Religious' },
//   { value: 'E05', label: 'Personal' },
//   { value: 'E06', label: 'Funeral' },
//   { value: 'E07', label: 'Medical Appointment' },
//   { value: 'E08', label: 'Illness' },
// ];

export const relationship = [
  { value: 'Father', label: 'Father' },
  { value: 'Mother', label: 'Mother' },
  { value: 'Guardian', label: 'Guardian' },
  { value: 'Other', label: 'Other' },
];

export const monthArray = [
  { key: '01', value: 'Jan' }, { key: '02', value: 'Feb' },
  { key: '03', value: 'Mar' }, { key: '04', value: 'Apr' },
  { key: '05', value: 'May' }, { key: '06', value: 'Jun' },
  { key: '07', value: 'Jul' }, { key: '08', value: 'Aug' },
  { key: '09', value: 'Sep' }, { key: '10', value: 'Oct' },
  { key: '11', value: 'Nov' }, { key: '12', value: 'Dec' },
];

export const dayArray = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10',
  '11', '12', '13', '14', '15', '16', '17', '18', '19', '20',
  '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];

export const getYears = (lowest, highest) => {
  const yearArray = [];
  for (let i = 0; i <= highest - lowest; i += 1) {
    yearArray.push(lowest + i);
  }
  return yearArray;
};

// export const getDay = (day) => {
//   if (day < 10) {
//     return `0${day}`;
//   }
//   return day.toString();
// };
